import React from "react";
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import RoundedButton from '../../elements/form/button/RoundedButton';
import {catalogLink, nonLoggedInUsersRedirectUrl} from '../../../config/app';
import { featuresPricingSubscriptionButton } from '../../../constants/classes/features';
import {getLandingSubscriptionButtonLink} from "../../../helpers/subscription";

class PriceCard extends React.PureComponent {
    state = {
        isLoading: false,
    };
    clickLoggedNoTrialHandler = () => {
        const { history } = this.props;

        return history.push(catalogLink);
    };
    clickHandler = () => {
        const { isSubscription, history, subscriptionState, isLogged } = this.props;

        if (!isLogged) {
            return history.push(`/${nonLoggedInUsersRedirectUrl}${catalogLink}`);
        }
        if (!isSubscription) {
            return history.push('/catalog');
        }

        return history.push(getLandingSubscriptionButtonLink(subscriptionState));
    };

    renderPrice = (price) => {
        let amount = price,
            fraction;

        if (price && price % 1 !== 0) {
            [ amount, fraction ] = price.toString().split('.');
        }

        return (
            <div className={'amount'}>
                <div className={'integer'}>
                    {amount}
                </div>

                {fraction ? <div className={'fraction'}>.{fraction}</div> : ''}
            </div>
        )
    };

    render() {
        let { title, price, payType, styleType, isLoading, isSubscription } = this.props;

        return (
            <div className={'price-card ' + styleType}>
                <div className={'title'}>{title}</div>

                <div className={'price-data'}>
                    <div className={'currency'}>$</div>
                    {this.renderPrice(price)}
                </div>

                <div className={'pay-type'}>{payType}</div>

                <div>
                    <RoundedButton
                        className={isSubscription ? featuresPricingSubscriptionButton : ''}
                        isDisabled={false}
                        onClick={this.clickHandler}
                        isLoading={isLoading}
                        value={isSubscription ? 'Get started' : 'Browse'}
                    />
                </div>
            </div>
        );
    }
}

PriceCard.propTypes = {
    isLogged: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isSubscription: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    payType: PropTypes.string.isRequired,
    styleType: PropTypes.string.isRequired,
    subscriptionState: PropTypes.string.isRequired
};

export default withRouter(PriceCard);